import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import caiDatDSDichVu from "@/pages/CaiDatDSDichVu.vue";
import loginPage from "@/pages/LoginPage.vue";
import Home from "@/pages/Home.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/caiDatDSDichVu',
    name: 'caiDatDSDichVu',
    component: caiDatDSDichVu,
    props: true
  },
  {
    path: '/',
    name: 'caiDatDSDichVu',
    component: caiDatDSDichVu,
    props: true
  },
  {
    path: '/login',
    name: 'login',
    component: loginPage,
    props: true
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
